import { createQueryData } from '../helpers/createQueryData';

const { useQuery: useAddressStagesQuery } = createQueryData({
  endPoint: 'Acceptance/stage_address_life_cycle',
  options: {
    errorMessage: 'Не удалось получить список возможных стадий помещений',
  },
});

export { useAddressStagesQuery };
